import React, { useState, useEffect, Fragment, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import { loginStatus, logout, authFail } from "../../actions/userActions";
import { Modal, Button } from "react-bootstrap";
import i18n from "i18next";
import { useTranslation, initReactI18next } from "react-i18next";
import common_en from "../../translations/en/common.json"
import common_de from "../../translations/de/common.json"
import common_nl from "../../translations/nl/common.json"
import { useDispatch } from "react-redux";
import { clubIDContext } from "../Admin";
// Prime React Property
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import "primereact/resources/themes/lara-light-indigo/theme.css";  //theme
import "primereact/resources/primereact.min.css";                  //core css
import "primeicons/primeicons.css";
import "./club.css";

i18n
  .use(initReactI18next)
  .init({
    interpolation: { escapeValue: false },  // React already does escaping
    lng: 'en',                              // language to use
    resources: {
      en: {
        common: common_en
      },
      de: {
        common: common_de
      },
      nl: {
        common: common_nl
      }
    },
  });

const Club = () => {
  const { t } = useTranslation('common')
  const history = useHistory()
  const position = {
    0: "Player",
    70: "Assistant",
    80: "Coach",
    100: "Manager",
  };
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  // const clubId = userInfo !== null ? userInfo.club_id : null;

  //const clubId = JSON.parse(localStorage.getItem("clubID")).spyClub !== "" ? JSON.parse(localStorage.getItem("clubID")).spyClub : ""

  const dispatch = useDispatch()
  const [adminClub, setAdminClub] = useContext(clubIDContext)

  const [members, setMembers] = useState([]);
  const [filterMember, setFilterMember] = useState([]);
  const [club, setClub] = useState({});
  const [scenarioCount, setScenarioCount] = useState(0);
  const [clubTeams, setClubTeams] = useState([]);
  const [teamName, setTeamName] = useState({ name: "", club_id: adminClub.spy });
  const [isUpdated, setIsUpdated] = useState(false)
  const [clubLogo, setClubLogo] = useState(null);
  const [searchName, setSearchName] = useState("");
  const [errors, setErrors] = useState({ teamName: false });
  const [invitationError, setInvitationError] = useState()

  const token = userInfo !== null ? userInfo.token : null;
  const [isUpdate, setIsUpdate] = useState(false);
  // --- NEW: scenario quick upload & recent list ---
  const [defaultFolderId, setDefaultFolderId] = useState(null);
  const [recentScenarios, setRecentScenarios] = useState([]);
  const [recentLoading, setRecentLoading] = useState(false);
  const [viewMode, setViewMode] = useState('grid');

  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => {
    setShowModal(false);
  };
  const inviteMember = (e) => {
    e.preventDefault()
    setInvitationError()
    setShowModal(true);
  };
  const [formInviteMember, setFormInviteMember] = useState({
    email: '',
    clubId: '',
    senderName: '',
    senderEmail: ''
  })
  const sendInvitation = async (e) => {
    e.preventDefault()
    try {
      const invitation = await axios.post(`${process.env.REACT_APP_BACKEND_URL}/api/v1/email/invitation`, formInviteMember)
      setShowModal(false)
    } catch (error) {
      setInvitationError(error.response.data.msg)
    }
  }
  const onChangeModal = (e) => {
    setFormInviteMember({ ...formInviteMember, [e.target.name]: e.target.value, clubId: adminClub.spy, senderName: userInfo.user_name, senderEmail: userInfo.user_email })
  }

  const config = {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  };

  const configLogo = {
    headers: {
      "Content-Type": "multipart/form-data",
      Authorization: `Bearer ${token}`,
    },
  };

  useEffect(() => {
    let alive = true;
    if (!adminClub.spy) return;

    const base = process.env.REACT_APP_BACKEND_URL;

    const load = async () => {
      try {
        // 1) 기존: 클럽 데이터 로드
        const { data } = await axios.get(
          `${base}/api/v1/club/data/${adminClub.spy}?search=${searchName}`,
          config
        );
        if (!alive) return;
        console.log('Club Data Response:', data);
        setClub(data.club);
        setScenarioCount(data.scenarioCount);
        setClubTeams(data.clubTeam);
        setMembers(data.members);
        setFilterMember(data.members);
      } catch (err) {
        if (err?.response?.status === 401) {
          dispatch(loginStatus());
        } else {
          console.warn("[club] fail", err);
        }
      }

      try {
        // 2) 추가: 최근 시나리오 로드
        const res = await axios.get(
          `${base}/api/v1/scenarios/recent?limit=6`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (!alive) return;
        const items = Array.isArray(res.data)
          ? res.data
          : Array.isArray(res.data?.items)
            ? res.data.items
            : [];
        setRecentScenarios(items);
        // 필요하면 여기서 setDefaultFolderId(...)도 채우세요
      } catch (err) {
        console.warn("[recent] fail", err?.response?.status, err?.message);
        if (alive) setRecentScenarios([]); // 실패 시 빈 목록 표시
      }

      try {
        const countRes = await axios.get(
          `${base}/api/v1/scenarios/count/user`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        if (alive) setScenarioCount(countRes.data.count);
      } catch (err) {
        console.warn("[count] fail", err?.response?.status, err?.message);
      }
    };

    load();
    return () => { alive = false; };
  }, [adminClub.spy, searchName, isUpdated]);

  const addTeam = async (e) => {
    e.preventDefault();
    if (teamName.name === "") {
      setErrors({ ...errors, teamName: true });
      return;
    }
    try {
      const team = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/api/v1/club/team`,
        teamName,
        config
      );
      setTeamName({ ...teamName, name: "" });
      setIsUpdate(!isUpdate);
    } catch (error) {
      console.log("error");
    }
  };

  const onChange = (e) => {
    setErrors({ ...errors, teamName: false });
    setTeamName({ ...teamName, [e.target.name]: e.target.value });
  };

  const onChangeSearch = (e) => {
    const filter = filterMember.filter((member) => {
      return (
        new RegExp(".*" + e.target.value + ".*", "i").test(member.name) ||
        new RegExp(".*" + e.target.value + ".*", "i").test(member.email)
      );
    });
    setMembers(filter);
  };

  const onChangeLogo = (e) => {
    if (e.target.files && e.target.files.length === 1) {
      setClubLogo(e.target.files[0]);
    }
  };

  const uploadLogo = async (e) => {
    e.preventDefault();
    const formData = new FormData();
    formData.append("image", clubLogo);
    const upload = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}/api/v1/club/logo/${adminClub.spy}`,
      formData,
      configLogo
    );
    document.querySelector('input[name="image"]').value = null;
    setIsUpdate(!isUpdate);
  };

  // Start Group Function to confirm PrimeReact Confirmation Box
  const confirm2 = (id, e) => {
    e.preventDefault()
    confirmDialog({
      message: 'Do you want to delete this user from club?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      acceptClassName: 'p-button-danger',
      accept: () => accept(id),
      reject
    });
  };
  const accept = async (id) => {
    const permission = await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/v1/club/member/${id}`, config)
    setIsUpdated(!isUpdated)
  }
  const reject = () => {

  }
  // End Group Function to confirm PrimeReact Confirmation Box

  function Capitalize(words) {
    return words.charAt(0).toUpperCase() + words.slice(1)
  }

  return (
    <div className="container-fluid loaded" style={{ display: "block" }}>
      <div className="row">
        <div className="col-12">
          <div className="page-title-box">
            <div className="page-title-right">
              <ol className="breadcrumb">
                <li className="breadcrumb-item active">Dashboard</li>
              </ol>
            </div>
            <h4 className="page-title">Dashboard</h4>
          </div>
        </div>
      </div>
      <div className="form-messages"></div>
      {adminClub.spy !== "" &&
        <div className="clubContent">
          <div className="row">
            {/* <div className="col-12 col-sm-8"> */}
            <div className="col-12">
              <div className="card club-card">
                <div className="card-body py-2 px-3">
                  <div className="d-flex align-items-center justify-content-between flex-wrap">
                    <div className="d-flex align-items-center">
                      <img
                        src={`${process.env.REACT_APP_BACKEND_URL}/images/logo-red.png`}
                        className="rounded mr-3"
                        style={{ height: "48px", padding: "4px" }}
                        alt="Club Logo"
                      />
                      <h4 className="mb-0 club-title" style={{ fontSize: '1.25rem' }}>{club.name}</h4>
                    </div>

                    <div className="d-flex align-items-center mt-2 mt-md-0">
                      <div className="vertical-divider d-none d-md-block"></div>
                      <div className="d-flex align-items-center mr-4">
                        <i className="fa fa-film mr-2 text-muted"></i>
                        <span className="meta-label">Scenarios:</span>
                        <span className="meta-value">{scenarioCount}</span>
                      </div>
                      <div className="d-flex align-items-center">
                        <span className="meta-label">License:</span>
                        <span className="status-pill">Active</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="col-12 col-sm-4">
              <div className="card">
                <div className="card-header">
                  <h4 className="mb-1 mt-1">Teams</h4>
                </div>
                <div className="card-body">
                  {clubTeams.map((team) => (
                    <Fragment key={team.team_id}>
                      <Link to={`/club/team/${team.team_id}`}>{team.name}</Link>
                      <br />
                    </Fragment>
                  ))}
                  <br />
                  <form onSubmit={addTeam}>
                    <div className="input-group mt-2">
                      <input
                        type="text"
                        name="name"
                        style={{ border: errors.teamName ? "solid 1px red" : "" }}
                        onChange={onChange}
                        value={teamName.name}
                        className="form-control"
                        placeholder="Team name..."
                        aria-label="Team name"
                        aria-describedby="button-team"
                      />
                      <div className="input-group-append">
                        <button
                          className="btn btn-outline-success"
                          name="op"
                          value="Add"
                          type="submit"
                          id="button-team"
                        >
                          Add
                        </button>
                      </div>
                    </div>
                    {errors.teamName && (
                      <p style={{ color: "red", fontWeight: 500 }}>
                        <i>Team name cannot be empty</i>
                      </p>
                    )}
                  </form>
                </div>
              </div>
            </div> */}
          </div>
          <div className="row">
            <div className="col-12">
              <div className="card mt-1">
                <div className="card-header d-flex justify-content-between align-items-center">
                  <h4 className="mb-1 mt-1">Recent Scenarios</h4>
                  <div className="d-flex align-items-center">
                    <div className="btn-group mr-3" role="group" aria-label="View Mode">
                      <button
                        type="button"
                        className={`btn btn-sm ${viewMode === 'list' ? 'btn-secondary' : 'btn-light'}`}
                        onClick={() => setViewMode('list')}
                        title="List View"
                        style={{ boxShadow: 'none' }}
                      >
                        <i className="fa fa-list"></i>
                      </button>
                      <button
                        type="button"
                        className={`btn btn-sm ${viewMode === 'grid' ? 'btn-secondary' : 'btn-light'}`}
                        onClick={() => setViewMode('grid')}
                        title="Grid View"
                        style={{ boxShadow: 'none' }}
                      >
                        <i className="fa fa-th-large"></i>
                      </button>
                    </div>
                    {/* <Link to={`/scenarios/add/${defaultFolderId}`} className="btn btn-success btn-lg"> */}
                    <Link to={`/scenarios/add/${defaultFolderId}`} className="btn btn-hero">
                      <i className="fa fa-fw fa-plus"></i> Add Scenario
                    </Link>
                  </div>
                </div>

                <div className="card-body">
                  {viewMode === 'list' ? (
                    <div className="table-responsive">
                      <table className="table w-100" style={{ borderCollapse: 'collapse', borderSpacing: '0' }}>
                        <thead style={{ backgroundColor: '#f8f9fa' }}>
                          <tr>
                            <th style={{ padding: '12px', borderBottom: '2px solid #dee2e6', width: '40%', color: '#6B7280', border: 'none', fontSize: '12px', fontWeight: '600', letterSpacing: '0.05em', fontFamily: 'inherit' }}>Scenario</th>
                            <th style={{ padding: '12px', borderBottom: '2px solid #dee2e6', width: '20%', color: '#6B7280', border: 'none', fontSize: '12px', fontWeight: '600', letterSpacing: '0.05em', fontFamily: 'inherit' }}>Created</th>
                            <th style={{ padding: '12px', borderBottom: '2px solid #dee2e6', width: '15%', textAlign: 'right', color: '#6B7280', border: 'none', fontSize: '12px', fontWeight: '600', letterSpacing: '0.05em', fontFamily: 'inherit' }}>Duration</th>
                            <th style={{ padding: '12px', borderBottom: '2px solid #dee2e6', width: '20%', textAlign: 'right', color: '#6B7280', border: 'none', fontSize: '12px', fontWeight: '600', letterSpacing: '0.05em', fontFamily: 'inherit' }}>Status</th>
                            <th style={{ padding: '12px', borderBottom: '2px solid #dee2e6', width: '5%', textAlign: 'right', color: '#6B7280', border: 'none', fontSize: '12px', fontWeight: '600', letterSpacing: '0.05em', fontFamily: 'inherit' }}></th>
                          </tr>
                        </thead>
                        <tbody>
                          {(recentScenarios ?? []).slice(0, 5).map((s, idx) => {
                            const sid = s.id ?? s.scenarioId ?? idx;
                            const name = s.name ?? s.title ?? `Scenario ${idx + 1}`;
                            const date = s.datedt;
                            const viewHref = s.url ?? `/scenarios/${sid}`;
                            const editHref = s.edit_url ?? `/scenarios/${sid}/edit`;
                            const formattedDate = date ? (() => {
                              const d = new Date(date);
                              const now = new Date();
                              const isToday = d.getDate() === now.getDate() && d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
                              const isYesterday = d.getDate() === now.getDate() - 1 && d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear(); // Simplified yesterday check

                              const hours = String(d.getHours()).padStart(2, '0');
                              const minutes = String(d.getMinutes()).padStart(2, '0');

                              if (isToday) return `Today ${hours}:${minutes}`;
                              // Note: Accurate yesterday check handles month/year boundaries, but for simplicity in this snippet:
                              // A more robust check:
                              const yesterday = new Date(now);
                              yesterday.setDate(yesterday.getDate() - 1);
                              if (d.getDate() === yesterday.getDate() && d.getMonth() === yesterday.getMonth() && d.getFullYear() === yesterday.getFullYear()) {
                                return `Yesterday ${hours}:${minutes}`;
                              }

                              const day = String(d.getDate()).padStart(2, '0');
                              const year = d.getFullYear();
                              const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                              const month = months[d.getMonth()];
                              return `${day}-${month}-${year} ${hours}:${minutes}`;
                            })() : '';
                            return (
                              <tr key={sid} onClick={() => history.push(`/scenarios/edit/${s.scenario_id}`)} style={{ cursor: 'pointer' }}>
                                <td style={{ padding: '12px', borderBottom: '1px solid #dee2e6', color: '#313a46', border: 'none' }}>{s.name}</td>
                                <td className="text-muted" style={{ padding: '12px', borderBottom: '1px solid #dee2e6', color: '#313a46', border: 'none' }}>{formattedDate}</td>
                                <td className="text-muted" style={{ padding: '12px', borderBottom: '1px solid #dee2e6', textAlign: 'right', color: '#313a46', border: 'none' }}>
                                  {s.duration ? `${Math.floor(s.duration / 3600)}:${Math.floor((s.duration % 3600) / 60).toString().padStart(2, '0')}:${Math.floor(s.duration % 60).toString().padStart(2, '0')}` : '-'}
                                </td>
                                <td style={{ padding: '12px', borderBottom: '1px solid #dee2e6', textAlign: 'right', color: '#313a46', border: 'none' }}>
                                  {s.positionalData
                                    ? s.positionalData === 'processing'
                                      ? <span className="badge badge-primary">{Capitalize(s.positionalData) + "..."}</span>
                                      : s.positionalData === 'error'
                                        ? <span className="badge badge-danger btn-hero">{Capitalize(s.positionalData)}</span>
                                        : s.positionalData === 'onvtserver'
                                          ? <span className="badge badge-warning badge-ghost">In Progress</span>
                                          : <span className="badge badge-success badge-done">{Capitalize(s.positionalData)}</span>
                                    : <span className="badge badge-warning badge-hero">N/A</span>
                                  }
                                </td>
                                <td style={{ padding: '12px', borderBottom: '1px solid #dee2e6', textAlign: 'right', color: '#343a40', border: 'none', whiteSpace: 'nowrap' }}>
                                  <Link to={`/scenarios/edit/${s.scenario_id}`} className="action-icon-red" title="Play 3D" style={{ marginRight: '8px' }}>
                                    <i className="fa fa-play"></i>
                                  </Link>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="row">
                      {(recentScenarios ?? []).slice(0, 6).map((s, idx) => {
                        const sid = s.id ?? s.scenarioId ?? idx;
                        const name = s.name ?? s.title ?? `Scenario ${idx + 1}`;
                        const date = s.datedt;
                        const formattedDate = date ? (() => {
                          const d = new Date(date);
                          const now = new Date();
                          const isToday = d.getDate() === now.getDate() && d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
                          const hours = String(d.getHours()).padStart(2, '0');
                          const minutes = String(d.getMinutes()).padStart(2, '0');
                          if (isToday) return `Today ${hours}:${minutes}`;
                          const day = String(d.getDate()).padStart(2, '0');
                          const year = d.getFullYear();
                          const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
                          const month = months[d.getMonth()];
                          return `${day}-${month}-${year} ${hours}:${minutes}`;
                        })() : '';

                        return (
                          <div key={sid} className="col-xl-4 col-lg-6 col-md-6 mb-4">
                            <div
                              className="h-100"
                              style={{ cursor: 'pointer', border: 'none', backgroundColor: 'transparent' }}
                              onClick={() => history.push(`/scenarios/edit/${s.scenario_id}`)}
                            >
                              <div className="scenario-thumbnail-container">
                                <div style={{ paddingTop: '56.25%', position: 'relative', backgroundColor: '#343a40' }}>
                                  {s.thumbnail_image ? (
                                    <img
                                      src={s.thumbnail_image.startsWith('http') ? s.thumbnail_image : `data:image/jpeg;base64,${s.thumbnail_image}`}
                                      alt={name}
                                      style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover' }}
                                    />
                                  ) : (
                                    <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#6c757d' }}>
                                      <i className="fa fa-image fa-3x"></i>
                                    </div>
                                  )}

                                  {/* Hover Overlay with Play Button */}
                                  <div className="scenario-thumbnail-overlay">
                                    <div className="play-button-overlay">
                                      <i className="fa fa-play"></i>
                                    </div>
                                  </div>

                                  {/* Duration Overlay */}
                                  {s.duration && (
                                    <div style={{
                                      position: 'absolute',
                                      bottom: '8px',
                                      right: '8px',
                                      backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                      color: 'white',
                                      padding: '2px 6px',
                                      borderRadius: '4px',
                                      fontSize: '12px',
                                      fontWeight: '500',
                                      zIndex: 10
                                    }}>
                                      {`${Math.floor(s.duration / 3600)}:${Math.floor((s.duration % 3600) / 60).toString().padStart(2, '0')}:${Math.floor(s.duration % 60).toString().padStart(2, '0')}`}
                                    </div>
                                  )}

                                  {/* Error Status Overlay */}
                                  {s.positionalData === 'error' && (
                                    <div style={{ position: 'absolute', top: '8px', right: '8px', zIndex: 10 }}>
                                      <span className="badge badge-danger">Error</span>
                                    </div>
                                  )}
                                </div>
                              </div>

                              <div className="mt-2 text-center">
                                <h5 className="mb-1 text-truncate" style={{ fontSize: '14px', fontWeight: 'bold', color: '#343a40' }}>{name}</h5>
                                <p className="mb-0 text-muted" style={{ fontSize: '12px' }}>
                                  {formattedDate}
                                </p>
                              </div>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
          {/* <div className="row">
            <div className="col-12">
              <div className="card">
                <div className="card-header">
                  <div className="app-search search-form float-right">
                    <div className="form-group position-relative">
                      <input
                        type="text"
                        name="search"
                        onChange={onChangeSearch}
                        className="form-control"
                        placeholder="Search by name or email..."
                      />
                      <span className="fa fa-search search-icon"></span>
                    </div>
                  </div>
                  <h4 className="mb-1 mt-1">Members</h4>
                </div>
                <div className="card-body">
                  <table id="tbl0" className="table">
                    <thead>
                      <tr>
                        <th width="32"></th>
                        <th>Club</th>
                        <th>Name</th>
                        <th>Email</th>
                        <th>Access level</th>
                        <th width="80">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {members.map((member, index) => {
                        return (
                          <tr key={index}>
                            <td>
                              <img
                                src={
                                  process.env.REACT_APP_BACKEND_URL +
                                  "" +
                                  member.image
                                }
                                alt="user-image"
                                className="rounded"
                                style={{ width: "32px" }}
                              />
                            </td>
                            <td>{club.name}</td>
                            <td>{member.name}</td>
                            <td>{member.email}</td>
                            <td>{position[member.accessLevel]}</td>
                            <td>
                              <Link
                                to={`/club/editmember/${member.uid}`}
                                title="Edit"
                              >
                                <i className="icon-button fa fa-border fa-pencil pencil-alt color-green-bg"></i>
                              </Link>
                              <a href="" onClick={(e) => confirm2(member.uid, e)}><i className="icon-button fa fa-border fa-trash trash-alt color-red-bg"></i></a>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                  <form
                    name="form3"
                    action="/en/club"
                    method="post"
                    className="form-horizontal"
                  >
                    <a href="#!" onClick={inviteMember} className="button">
                      <i className="fa fa-fw fa-plus"></i>&nbsp;{t('Add')}
                    </a>
                    <input type="hidden" name="op" value="" />
                  </form>
                </div>
              </div>
            </div>
          </div> */}
          <Modal show={showModal} onHide={handleCloseModal}>
            <Modal.Header closeButton>
              <Modal.Title>Invite Member</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div className="form-group row">
                <label className="col-4 col-form-label">Email:</label>
                <div className="col-8">
                  <input
                    type="email"
                    required=""
                    className="form-control"
                    maxLength="128"
                    name="email"
                    value={formInviteMember.email}
                    onChange={onChangeModal}
                    placeholder="example@email.com"
                    style={{ border: invitationError ? '1px solid red' : '' }}
                  />
                  {invitationError && <p style={{ color: 'red', fontStyle: 'italic', fontWeight: 600, fontSize: '13px', marginTop: '3px' }}>{invitationError}</p>}
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <button
                type="button"
                className="btn button button-cancel"
                data-dismiss="modal"
                onClick={handleCloseModal}
              >
                <i className="fa fa-fw fa-ban"></i> Cancel
              </button>
              <button
                type="button"
                className="btn button"
                onClick={sendInvitation}
              >
                <i className="fa fa-fw fa-floppy-o"></i> Invite
              </button>
            </Modal.Footer>
          </Modal>
        </div>
      }
      {
        adminClub.spy === "" && <p>You are not a member a club</p>
      }
      <ConfirmDialog />
    </div>
  );
};

export default Club;
